import { html, render } from "lit-html";
import { track } from "../../tracker/EventTracker";
import { stateful } from "../../../shared/components/element-builder";
import { translate } from "../../../shared/l10n/translate";
import "../InformationDropdown";

customElements.define(
	"esc-hotel-list-sorting-info",
	stateful(
		class extends HTMLElement {
			static getInitialState() {
				return {
					showDropdown: false,
				};
			}

			render() {
				const template = html`<div>
					<button
						@click=${this.onButtonClick}
						class="sorting-info__button"
						aria-label="${translate("list_sorting_info_button_aria_label")}"
					>
						<i class="sorting-info__button__icon fa fa-info-circle"></i>
					</button>
					<esc-information-dropdown
						?open=${this.showDropdown}
						@change=${this.onDropdownChange}
						info-text=${translate("hotel_list_sorting_info")}
						details-url=${translate("hotel_list_sorting_info_details_url")}
						details-label=${translate("hotel_list_sorting_info_details_label")}
					></esc-information-dropdown>
				</div>`;
				render(template, this, { host: this });
			}

			onDropdownChange({ detail }) {
				this.showDropdown = detail.open;
				track(
					"Liste",
					"Sortierung",
					`Info Popularitaet ${detail.open ? "oeffnen" : "schliessen"}`,
					null,
				);
			}

			onButtonClick(event) {
				event.stopPropagation();
				this.showDropdown = !this.showDropdown;
			}
		},
	),
);
